import moment from "moment"
import html2canvas from 'html2canvas'
import jspdf from 'jspdf'
import MDBox from "../components/MDBox"
import MDTypography from "../components/MDTypography"
import PrintIcon from '@mui/icons-material/Print';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import LbicButton from "../components/lbic_component/LbicButton"
import PropTypes from "prop-types";

const Certificate = (props) => {
    const width = window.screen.width;
    const certificate = props.certificate || {
        ownerName: "John Doe",
        start_date: new Date(),
        // Add other mock data as needed
    };
    const month = moment(certificate.start_date).get('month') + 1
    // console.log(moment(certificate.start_date).get('month'),certificate.start_date)
    const fomatedDate = (num) => {
        let value = toString(num)
            if(value.endsWith('1')){
                return num+'st'
            }
            if(value.endsWith('2')){
                return num+'nd'
            }if(value.endsWith('3')){
                return num+'rd'
            }else{
                return num+'th'
            }
    }

    // console.log(fomatedDate(month))
    return(
        <div className="certificate-container">
            <div className="certificate">
            <MDBox className="bottom-space">
                <MDTypography className="medium-text text-align-left text bold">Lagos Building Investment Company Plc</MDTypography>
                <MDTypography className="below-text text-align-left text text-line">Assibiffi Road</MDTypography>
                <MDTypography className="bewlow-text text-align-left text text-line">Alausa, Ikeja, Lagos</MDTypography>
            </MDBox>
            <MDBox className="certificate-body">
                <MDBox className="body-heading">
                    <MDTypography className="border-box text">INSURANCE CERTIFICATE</MDTypography>
                    <MDTypography className="small-text text">CERTIFICATE NO: LBIC/INS/.......</MDTypography>
                </MDBox>
                <MDBox className="main-body">
                    <MDBox>
                        <MDTypography  className="text">Name of Insured Person <span className="dotted"> {certificate.ownerName} </span></MDTypography>
                    </MDBox>
                    <MDBox className="bottom-space">
                        <MDTypography className="text">Block <span className="dotted">{'Block Number'}</span> Flat <span className="dotted">{'flat number'}</span> of <span className="dotted">{'Some'}</span> Estate</MDTypography>
                        <MDTypography className="text">Sum Insured # <span className="dotted">{}</span> Period of 
                            Insurance <span className="dotted">{}</span>
                        </MDTypography>
                    </MDBox>
                    <MDBox>
                        <div className="bottom-space">
                        <MDTypography className="text text-line">
                            This is to certify that the property specified above is
                            insured under the Fire and Special Peril Insurance Policy No:
                            <b>FR/09/00136/LA.</b>
                        </MDTypography></div>
                        <MDTypography className="text text-line">
                            This certificate entitles the holders to have insurance
                            compensation according to the terms and conditions of the
                            stated policy.
                        </MDTypography>
                    </MDBox>
                </MDBox>
                <MDBox><MDTypography className="text">Signed this<span className="dotted">{fomatedDate(moment(certificate.start_date).get('date'))}</span> day of <span className="dotted">{month} / </span>{moment().year()}</MDTypography></MDBox>
            </MDBox>
            </div>
            <div className="row justify-content-between" id="invoice-footer">
                <div className="col-md-3 text-right identity download_section">
                <LbicButton
                  onClick={() => {
                    const pageHTML = document.querySelector('.certificate');
                    html2canvas(pageHTML).then((res) => {
                        const imgData = res.toDataURL('image/png')
                        const pdf = new jspdf('p', 'pt', 'a4', false)
                        pdf.addImage(imgData, 'PNG', 10, 80, 500, 0, certificate.ownerName, false)
                        pdf.save(certificate.ownerName+'_certificate')
                    })
                  }}
                  icon={<SystemUpdateAltIcon sx={{ marginRight: 1 }}/>}
                  title="Download"
                  color="success"
                  className='button-center'
                />

                
              </div>
              <div className="col-md-3 text-right identity reciept_section">
                <LbicButton
                onClick={() => {
                    window.print()
                }}
                icon={<PrintIcon sx={{ marginRight: 1 }}/>}
                  title="Print Reciept"
                  color="success"
                  className='button-center'
                />
              </div>

                
              </div>
        </div>
    )
}

Certificate.propTypes = {
    certificate: PropTypes.shape({
        ownerName: PropTypes.string.isRequired,
        start_date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
        // Add other required fields here
    }),
};

export default Certificate;